<div class="container">
  <app-ch-skeleton *ngIf="isVesselLoading" variant="form" [rows]="4"></app-ch-skeleton>
  <div class="filter-card" *ngIf="!isVesselLoading" [ngClass]="{ 'dark-card': isDarkMode() }">
    <div class="card-header">
      <h3>Cargo Heating Analytics</h3>
      <p>Select vessel and month to view detailed analytics</p>
    </div>
    <form [formGroup]="dashboardForm">
      <div class="filter-fields-vertical">
        
        <!-- Vessel IMO -->
        <div class="compact-multi-select full-width">
          <label class="field-label" [ngClass]="{ 'dark-label': isDarkMode() }">Vessel I.M.O</label>
          <input type="text" class="form-control" formControlName="shipImo" placeholder="Enter IMO"
            style="height: 45px; background: rgba(255, 255, 255, 0.05); border: 1.5px solid rgba(0, 0, 0, 0.1); border-radius: 8px; padding: 0 12px;" />
        </div>

        <!-- Vessel Name -->
        <div class="compact-multi-select full-width">
          <label class="field-label" [ngClass]="{ 'dark-label': isDarkMode() }">Vessel Name</label>
          <div class="select-box" (click)="toggleVesselDropdown($event)" style="height: 45px; border-color: rgba(0, 0, 0, 0.1);">
            <span>{{ dashboardForm.get('vesselname')?.value || 'Select Vessel' }}</span>
            <mat-icon>expand_more</mat-icon>
          </div>
          <div class="dropdown-panel" *ngIf="vesselDropdownOpen" (click)="$event.stopPropagation()" style="width: 100%;">
            <div class="search-container">
              <mat-icon>search</mat-icon>
              <input type="text" placeholder="Search Vessel..."
                (input)="vesselSearchQuery = $any($event.target).value">
            </div>
            <div class="options-list">
              <div class="option" *ngFor="let vessel of getFilteredVessels()" (click)="onVesselSelect(vessel)">
                <span>{{ vessel }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Month -->
        <div class="compact-multi-select full-width">
          <label class="field-label" [ngClass]="{ 'dark-label': isDarkMode() }">Month</label>
          <div class="select-box" (click)="toggleMonthDropdown($event)" style="height: 45px; border-color: rgba(0, 0, 0, 0.1);">
            <span>{{ dashboardForm.get('month')?.value || 'Select Month' }}</span>
            <mat-icon>expand_more</mat-icon>
          </div>
          <div class="dropdown-panel" *ngIf="monthDropdownOpen" (click)="$event.stopPropagation()" style="width: 100%;">
            <div class="search-container">
              <mat-icon>search</mat-icon>
              <input type="text" placeholder="Search Month..."
                (input)="monthSearchQuery = $any($event.target).value">
            </div>
            <div class="options-list">
              <div class="option" *ngFor="let month of getFilteredMonths()" (click)="onMonthSelect(month)">
                <span>{{ month }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="action-btn-container">
          <button class="fetch-btn" (click)="fetchClick()">
            <mat-icon>analytics</mat-icon>
            <span>Generate Report</span>
          </button>
          <button type="button" class="ok-btn" (click)="openWeeklyUpdatesModal()">
            OK
          </button>
        </div>
      </div>
    </form>
  </div>

  <app-weekly-updates-modal
    [isOpen]="showWeeklyUpdatesModal"
    (closed)="closeWeeklyUpdatesModal()">
  </app-weekly-updates-modal>
</div>
